document.querySelectorAll('.list-filter').forEach(($listFilter) => {
  const $selectFields = $listFilter.querySelectorAll('.select');
  const $submitButton = $listFilter.querySelector('.list-filter__submit');

  $selectFields.forEach(($selectField) => {
    $selectField.addEventListener('change', () => {
      $submitButton.removeAttribute('disabled');
      $submitButton.classList.add('list-filter__submit--active');
    });
  });
});
